var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import OperationReportService from '../../api/OperationReportService';
import RequiredMixin from '../../components/renderHeader/RequiredMixin';
import TableHeaderToolTip from '../purchaseOrderForUpperSup/components/TableHeaderToolTip.vue';
import Header from './components/Header.vue';
var OperationReport = (function (_super) {
    __extends(OperationReport, _super);
    function OperationReport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.summaryListData = [];
        _this.listData = [];
        _this.tableHeight = document.documentElement.clientHeight - 240;
        _this.radioRecord = 1;
        return _this;
    }
    OperationReport.prototype.created = function () {
        this.service = OperationReportService.getInstance();
    };
    OperationReport.prototype.search = function (filter) {
        this.filter = filter;
        this.radioRecord = filter.dimension;
        this.getList();
        if (this.Root_PageAuth.LookDetail)
            this.getExpandList();
    };
    OperationReport.prototype.getList = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getSummaryList(this.filter)
            .then(function (res) {
            loadingInstance.close();
            var DATA = res.data.data;
            _this.summaryListData = [DATA];
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    OperationReport.prototype.getExpandList = function () {
        var _this = this;
        this.service.getList(this.filter).then(function (res) {
            var DATA = res.data.data;
            _this.listData = Array.isArray(DATA) ? DATA : [];
        });
    };
    OperationReport = __decorate([
        Component({
            mixins: [RequiredMixin],
            components: {
                'list-header': Header,
                TableHeaderToolTip: TableHeaderToolTip,
            },
            methods: {
                renderHeaderIncomeLossMoney: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '库存报损+盘点报损',
                            placement: 'bottom',
                        },
                    }, '报损');
                },
                renderHeaderIncomeProfitMoney: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '库存报溢+盘点报溢',
                            placement: 'bottom',
                        },
                    }, '报溢');
                },
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '销售金额-销售成本-费用金额',
                            placement: 'bottom',
                        },
                    }, '利润');
                },
                renderHeaderRate: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: '利润/销售金额*100%',
                            placement: 'bottom',
                        },
                    }, '利润率（%）');
                },
            },
        })
    ], OperationReport);
    return OperationReport;
}(Vue));
export default OperationReport;
